import React from "react";
import { PrivateBannerSection } from "./privateBannerSection";
import WelcomeSection from "./welcomeSection";
import ServiceSection from "../QuinceneraPage/serviceSection";
import PackagesSection from "../QuinceneraPage/PackagesSection";
import VenueHighlightSection from "../HomePage/VenueHighlightSection";
import Gallery from "../QuinceneraPage/gallery";
import VenueHighlights from "../QuinceneraPage/venueHighlights";
import Amenities from "../QuinceneraPage/amenities";
import TestimonialSection from "../HomePage/TestimonialSection";
import BlogsSection from "../HomePage/BlogsSection";
import VideosSection from "../HomePage/VideosSection";
import EventTips from "./eventTips";
import PreferredVendorsSection from "../QuinceneraPage/preferredVendorsSection";

const PrivateParties = () => {
  return (
    <>
      <PrivateBannerSection />
      <WelcomeSection id={5} titleName={"Parties"} />
      <ServiceSection id={5} />
      <PreferredVendorsSection id={5} />
      <PackagesSection id={5} />
      <VenueHighlightSection />
      <Gallery id={5} titleName={"Parties"} />
      <VenueHighlights id={5} />
      <Amenities id={5} />
      <TestimonialSection id={5} />
      <VideosSection id={5} />
      <BlogsSection id={5} />
      <EventTips id={5} />
    </>
  );
};

export default PrivateParties;
